import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MerchantOfficeDetails from "../tabs/merchantOffficeDetails";
import MerchantBankDetails from "../tabs/merchantBankDetails";
import MerchantDeviceSelection from "../tabs/merchantDeviceSelection";

import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { merchantSchemaStep1, merchantSchemaStep2 } from "../../../models/merchantModel";

import useApi from "../../../components/Utils/api";

const steps = ["Merchant Details", "Bank Details", "Device Selection"];

function NewMerchant() {
  const api = useApi();
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(0);
  const [requiredInfo, setRequiredInfo] = useState({mcclist: [], });
  const [selectedDevices, setSelectedDevices] = useState([]);

  const formMethods = useForm({
    mode: "onChange",
    resolver: yupResolver(activeStep === 0 ? merchantSchemaStep1 : merchantSchemaStep2),
    defaultValues: {},
  });

  const { handleSubmit, getValues } = formMethods;

  /* ===================== FETCH MCC MASTER ===================== */
  useEffect(() => {
    api
      .get("mcc/all")
      .then((res) => {
        setRequiredInfo((prev) => ({
          ...prev,
          mcclist: res.data || [],
        }));
      })
      .catch(() => {
        setRequiredInfo((prev) => ({ ...prev, mcclist: [] }));
      });
  }, []);

  /* ===================== MCC FRONTEND VALIDATION ===================== */
  const isValidMcc = (mccCode) => requiredInfo?.mcclist.some((m) => String(m.mccCode) === String(mccCode));

  /* ===================== DEVICE SELECTION HANDLER ===================== */
  const handleDeviceSelectionChange = (newSelection) => {
    setSelectedDevices(newSelection);
  };

  /* ===================== SUBMIT HANDLER ===================== */
  const onSubmit = (data) => {
    if (activeStep < steps.length - 1) {
      setActiveStep((prev) => prev + 1);
      return;
    }

    // ✅ Build DTO-matching payload
    const merchantPayload = {
      name: data.name,
      counterId: data.counterId,
      vendorId: data.vendorId,

      beneficiaryName: data.beneficiaryName,
      beneficiaryAccountNo: data.beneficiaryAccountNo,
      bankCode: data.bankCode,
      branchCode: data.branchCode,
      transactionCode: data.transactionCode,
      transferType: data.transferType,
      settlementCurrency: data.settlementCurrency,

      email1: data.email1,
      phoneNumber: data.phoneNumber,

      mccCode: String(data.mccCode),

      firstName: data.firstName,
      lastName: data.lastName,
      address: data.address,
      city: data.city,
      state: data.state,
      pincode: data.pincode,

      deviceIds: selectedDevices,

      status: 1,
    };
  console.log("Creating merchant with payload: ", merchantPayload);
  api
  .post("adminPortal/merchant/create", merchantPayload)
  .then(() => {
    toast.success("Merchant created successfully");
    navigate("/merchants");
  })
  .catch((error) => {
    toast.error("Failed to create merchant");
    console.error(error);
  });
}
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box mt={6} mb={3}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={12}>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            <FormProvider {...formMethods}>
              <Box p={3}>
                {activeStep === 0 && <MerchantOfficeDetails editmode type="new" mccList={requiredInfo?.mcclist} />}
                {activeStep === 1 && <MerchantBankDetails editmode type="new" />}
                {activeStep === 2 && (
                  <MerchantDeviceSelection
                    selectedDevices={selectedDevices}
                    onDeviceSelectionChange={handleDeviceSelectionChange}
                    editMode
                  />
                )}
              </Box>
            </FormProvider>

            <Box display="flex" justifyContent="space-between" px={3}>
              <Button disabled={activeStep === 0} onClick={() => setActiveStep((s) => s - 1)}>
                Back
              </Button>

              <Button variant="contained" style={{ color: "#fff" }} onClick={handleSubmit(onSubmit)}>
                {activeStep === steps.length - 1 ? "Create Merchant" : "Next"}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </DashboardLayout>
  );
}

export default NewMerchant;
